import React, { useEffect, useState, useMemo } from "react";
import LineRaceChart from "../../CHARTS/LineRaceChart";
import KpiCard from "./KpiCard";
import NoDataFound from "../../Extra/NoDataFound";

const CrewUtilizationGraph = ({ data, selectedFilters, setPassedCD }) => {
  const [chartData, setChartData] = useState(null);
  const [monthCount, setMonthCount] = useState(1);
  const [lobbyCount, setLobbyCount] = useState(1);
  const [sumData, setSumData] = useState();
  const safeData = Array.isArray(data) ? data : [];
  const selectedYear = selectedFilters?.year || new Set();
  const selectedMonth = selectedFilters?.selectedMonth || new Set();
  const selectedLobby = selectedFilters?.selectedLobby || new Set();
  useEffect(() => {
    setMonthCount([...selectedFilters?.selectedMonth].length);
    setLobbyCount([...selectedFilters?.selectedLobby].length);
  }, [selectedFilters]);

  const filteredData = useMemo(() => {
    return safeData.filter(
      (d) =>
        (selectedYear.size === 0 || selectedYear.has(d.Year)) &&
        (selectedMonth.size === 0 || selectedMonth.has(d.Month)) &&
        (selectedLobby.size === 0 || selectedLobby.has(d.Lobby)),
    );
  }, [safeData, selectedYear, selectedMonth, selectedLobby]);

  const sumResult = useMemo(() => {
    if (!filteredData || filteredData.length === 0) return {};

    return filteredData.reduce((acc, curr) => {
      for (let key in curr) {
        if (typeof curr[key] === "number") {
          acc[key] = (acc[key] || 0) + curr[key];
        }
      }
      return acc;
    }, {});
  }, [filteredData]);
  // console.log(sumResult, [...selectedFilters.selectedMonth].length);

  const totalCrew = useMemo(() => {
    return filteredData.reduce(
      (sum, curr) => sum + (Number(curr.ut_no_of_crew) || 0),
      0,
    );
  }, [filteredData]);
  const totalTrips = useMemo(() => {
    return filteredData.reduce(
      (sum, curr) => sum + (Number(curr.ut_no_of_trips) || 0),
      0,
    );
  }, [filteredData]);

  const totalDutyHrs = useMemo(() => {
    return filteredData.reduce(
      (sum, curr) => sum + (Number(curr.ut_total_duty_hrs) || 0),
      0,
    );
  }, [filteredData]);
  const utilizationSummaryData = useMemo(() => {
    if (!filteredData || filteredData.length === 0) return [];

    // Group data by Month
    const monthGroups = {};
    filteredData.forEach((item) => {
      const month = item.Month;
      if (!monthGroups[month]) monthGroups[month] = [];
      monthGroups[month].push(item);
    });

    return Object.keys(monthGroups).map((month) => {
      const group = monthGroups[month];

      const totalCrew = group.reduce(
        (sum, row) => sum + (Number(row.ut_no_of_crew) || 0),
        0,
      );

      const avgUtilization =
        group.reduce((sum, row) => sum + (Number(row.ut_utilization) || 0), 0) /
        group.length;

      const avgFreightUtilization =
        group.reduce(
          (sum, row) => sum + (Number(row.ut_utilization_freight) || 0),
          0,
        ) / group.length;

      return {
        time: month,
        "No of Crew": totalCrew,
        "Utilization % (FGHT)": avgFreightUtilization.toFixed(2),
        "Utilization %": avgUtilization.toFixed(2),
      };
    });
  }, [filteredData]);
  useEffect(() => {
    if (!data || data.length === 0) return;

    let final = [];

    data.forEach((obj, ind) => {
      const isLast = ind === data.length - 1;

      // If month changes OR it's the last item → process the group
      if (
        ind > 0 &&
        (data[ind - 1].ut_month !== obj.ut_month ||
          data[ind - 1].ut_year !== obj.ut_year)
      ) {
        const prevMonth = data[ind - 1].ut_month;
        const prevYear = data[ind - 1].ut_year;

        const rowsToSum = data.filter(
          (d) => d.ut_month === prevMonth && d.ut_year === prevYear,
        );

        const sumResult = rowsToSum.reduce((acc, curr) => {
          for (let key in curr) {
            if (typeof curr[key] === "number") {
              acc[key] = (acc[key] || 0) + curr[key];
            }
          }
          acc["month"] = curr.ut_month;
          acc["year"] = curr.ut_year;
          return acc;
        }, {});

        final.push(sumResult);
      }

      // Special case: when array has only 1 item OR last group not processed
      if (isLast) {
        const rowsToSum = data.filter(
          (d) => d.ut_month === obj.ut_month && d.ut_year === obj.ut_year,
        );

        const sumResult = rowsToSum.reduce((acc, curr) => {
          for (let key in curr) {
            if (typeof curr[key] === "number") {
              acc[key] = (acc[key] || 0) + curr[key];
            }
          }
          acc["month"] = curr.ut_month;
          acc["year"] = curr.ut_year;
          return acc;
        }, {});

        // Avoid duplicate push (if already added above)
        if (
          !final.some(
            (f) => f.month === sumResult.month && f.year === sumResult.year,
          )
        ) {
          final.push(sumResult);
        }
      }
    });

    setSumData(final);
  }, [data]);

  useEffect(() => {
    let temp = [];
    let temp2 = [];
    let lobbyWise = [];
    if (sumData?.length > 0) {
      sumData.map((obj) => {
        temp = [
          ...temp,
          {
            time: obj.month,
            crew: (obj.ut_no_of_crew / lobbyCount).toFixed(0),
            "ut %": (obj.ut_percentage_util / lobbyCount).toFixed(0),
            "utf %": (obj.ut_percentage_util_fght / lobbyCount).toFixed(0),
          },
        ];
        temp2 = [
          ...temp2,
          {
            time: obj.month,
            crew: (obj.ut_no_of_crew / lobbyCount).toFixed(0),
            // RH: 45,
          },
        ];
        lobbyWise = [...lobbyWise, { time: obj.lobby }];
      });

      setChartData({ ...chartData, utfData: temp, temp2 });
      setPassedCD({ ...chartData, utfData: temp, temp2 });
    }
  }, [sumData, monthCount, data]);
  if (!data || data.length === 0) {
    return (
      <div style={{ padding: 20 }}>
        {/*  No data available for selected filters. */}
        <NoDataFound />
      </div>
    );
  }
  return (
    <div style={{ padding: 20 }}>
      <h2>🚉 Crew Performance Dashboard</h2>

      {/* KPI Cards */}
      <KpiCard
        data={{ sumData, selectedFilters }}
        totalCrew={totalCrew}
        totalTrips={totalTrips}
        totalDutyHrs={totalDutyHrs}
      />

      <div className="newUiBody">
        <div className="row">
          {/* Month-wise Chart */}
          <div className="col-md">
            <div className="">
              <div className="bg-dark text-white p-1 d-flex">
                <h5>Crew Utilization Graph</h5>
                <b className="pt-1" style={{ color: "rgba(189, 188, 188, 1)" }}>
                  (Month wise)
                </b>
              </div>

              {chartData && (
                <LineRaceChart from="monthWise" data={chartData.utfData} />
              )}
            </div>
          </div>

          {/*Hours-wise Chart */}
          {/* <div className="col-md">
            <div className="papaDiv">
              <div className="bg-dark text-white p-1 d-flex">
                <h5>Crew Running Duty Hours</h5>
                <b className="pt-1" style={{ color: "rgba(189, 188, 188, 1)" }}>
                  (Month wise)
                </b>
              </div> */}

          {/* {chartData && (
                <LineRaceChart from="hours" data={chartData.temp2} />
              )} */}
          {/* </div>
          </div> */}

          {/*Lobby-wise Chart */}
          {/* <div className="col-md-4">
            <div className="papaDiv">
              <div className="bg-dark text-white p-1 d-flex">
                <h5>Crew Utilization %</h5>
                <b className="pt-1" style={{ color: "rgba(189, 188, 188, 1)" }}>
                  (Month wise)
                </b>
              </div>

              {chartData && (
                <LineRaceChart from="lobbyWise" data={chartData.temp2} />
              )}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CrewUtilizationGraph;
